






































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'meta', 'allZones'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, [
      'addZone', 'removeZone', 'changeZoneValue'
    ])
  },
  validations() {
    const rules: any = {
      client_id: { required },
      city_id: { required },
      manager_id: { required },
      counterparty_id: {},
      address: { required, minLength: minLength(3) },
      address_to_wa: {},
      address_code: {},
      phone: {},
      init_input_plan: {},
      comment: {},
    }

    return {
      form: rules
    }
  }
})
export default class DeliveryPointForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  setArchive() {
    this.$store.dispatch(`${STORE_KEY}/setArchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть архивирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  setUnarchive() {
    this.$store.dispatch(`${STORE_KEY}/setUnarchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть активирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })    
  }

  public currentCity: any = null
  onCityChange($event: any) {
    if ($event) {
      this.currentCity = $event;
    }
  }

  getAsyncData(name: any){
    if (!name.length) {
        this.suggestions = [];
        return;
    }

    const locations = [];
    if (this.form.city_id.value) {
      if (this.currentCity) {
        locations.push({
          city: this.currentCity.label
        });
      }
    }

    this.isSuggestionsFetching = true;
    
    (this as any).$http
      .post(`/api/v1/dadata/suggestions/api/4_1/rs/suggest/address`, JSON.stringify({
        "query": name,
        locations,
        from_bound: { value: 'street' },
        // to_bound: { "value": "house" },
        count: 10
      }))
        .then(({ data }: any) => {
          this.$set(this, 'suggestions', data.suggestions);
        })
        .catch((error: any) => {
            this.suggestions = [];
            throw error
        })
        .finally(() => {
            this.isSuggestionsFetching = false
        })  
  }

  getAsyncDataDebounce = debounce(this.getAsyncData, 500)

  initFromSuggestion({ value, data, unrestricted_value }: any) {
    this.changeValue('address', value);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

